import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";

import menuQuery from "./menu-query.graphql";
import useHistoryState from "../../hooks/use-history-state";

export const Menu = ({
  menuName,
  showLabel = false,
  itemOnClickHandler,
  itemClassName = "",
  itemIcon,
  listClassName = "",
  location,
  navClassName = "",
}) => {
  const { loading, error, data } = useQuery(menuQuery, {
    variables: { name: menuName },
  });

  const historyState = useHistoryState();

  if (loading) {
    return "Loading...";
  }

  if (error) {
    return `Error! ${error.message}`;
  }

  return (
    <>
      {showLabel && <h2>{data.menuByName.label}</h2>}
      <nav className={`${data.menuByName.id} ${navClassName}`}>
        <ul className={listClassName}>
          {data.menuByName.links.map((item, index) => (
            <li
              onClick={() => (itemOnClickHandler ? itemOnClickHandler() : null)}
              className={itemClassName}
              key={index}
              data-active={
                item.link.url.path === location?.pathname || 
                item.link.url.path === historyState
              }
            >
              <NavLink to={item.link.url.path} title={item.link.description}>
                {itemIcon && itemIcon}
                {item.link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

Menu.propTypes = {
  menuName: PropTypes.string,
  showLabel: PropTypes.bool,
  itemOnClickHandler: PropTypes.func,
  itemClassName: PropTypes.string,
  itemIcon: PropTypes.element,
  listClassName: PropTypes.string,
  navClassName: PropTypes.string,
};
